import { createSelector } from 'reselect';

const getSeminars = state => state.seminars;
const getSeminarSpecificsObj = state => state.seminarSpecifics;
const getSeminarSpecificsIds = state => (state.pages.educationPage ? state.pages.educationPage.seminars : undefined);
const getSeminarSpecificsFromSeminarType = (state, seminar) => seminar.seminarSpecifics;
const getRecommendedSeminarsFromSeminarType = (state, seminar) => seminar.recommendedSeminars;
const getSlug = (state, props) => props.match.params.seminar;

export const getSeminar = createSelector([getSeminars, getSlug], (seminars, slug) => seminars[slug]);

export const getArraySeminars = createSelector([getSeminars], seminars =>
  Object.keys(seminars).map(slug => seminars[slug])
);

export const getArraySeminarSpecifics = createSelector([getSeminarSpecificsObj], seminarSpecifics =>
  Object.keys(seminarSpecifics).map(id => seminarSpecifics[id])
);

export const getSeminarSpecifics = createSelector(
  [getSeminarSpecificsObj, getSeminarSpecificsFromSeminarType],
  (seminarSpecifics, ids) => ids.map(id => seminarSpecifics[id])
);

export const getSeminarsFromPage = createSelector(
  [getSeminars, getSeminarSpecificsObj, getSeminarSpecificsIds],
  (seminars, seminarSpecifics, ids) =>
    ids
      ? ids.map(id => ({ ...seminarSpecifics[id], seminarType: seminars[seminarSpecifics[id].seminarType] }))
      : undefined
);

export const getRecommendedSeminars = createSelector(
  [getSeminars, getSeminarSpecificsObj, getRecommendedSeminarsFromSeminarType],
  (seminars, seminarSpecifics, ids) =>
    ids
      ? ids.map(id => ({
          ...seminarSpecifics[id],
          ...seminars[seminarSpecifics[id].seminarType],
        }))
      : null
);



// WEBPACK FOOTER //
// ./src/redux/selectors/seminars.js